<template lang="pug">
section
  .d-flex.row.flex-row.align-items-center
    .col
      h2.mb-4
        i Desarrollo personal (propio)
    .col-auto
      a.btn(title="Comentarios" @click.stop="openGeneralComments()")
        span.h5.ad_text-primary Comentarios
        i.icono.icono-comentarios.ad_text-primary.fa-2_5x.ml-3
  .d-flex.row.flex-row.align-items-start
    .col-12
      .card.ad_border1-secondary.rounded-xl
        h3.ad_text-primary
          i Competencias del Consultor     
        .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-if="personaldevelopments.length > 0")
          .d-flex.row
            .col-12
              table.w-100.text-center.table-rounded-body
                thead
                  tr
                    th
                    th.text-left Competencia
                    th Actividad
                    th Vencimiento
                    th Fecha creación
                    th Cumplimiento
                    th
                tbody
                  tr(v-for="(pdc, index) in personaldevelopments")
                    td
                      div.pr-0
                        span.num_circle.ad_bg-secondary {{index + 1}}
                    td
                      div
                        | {{pdc.category.name}}
                    td.w-50.text-left
                      div
                        | {{pdc.subcategory.name}}
                    td
                      div.justify-content-center
                        span.text-nowrap
                          | {{pdc.date_limit | DateFormat}}
                    td
                      div.justify-content-center
                        span.text-nowrap(:class="plazo > activo ? 'ad_text-successDark' : 'ad_text-danger'")
                          | {{pdc.date | DateFormat}}
                    td
                      div.justify-content-center(v-if="pdc.accomplished == true")
                        i.icon-checkmark.ad_text-success.icon--1-5x.align-middle
                      div.justify-content-center(v-if="pdc.accomplished == false")
                        i.icon-cross.ad_text-danger.icon--1-5x
                    td
                      div.pr-0
                        a.btn.btn-secondary.px-3.py-1(title="Actualizar", @click.stop="opendrawerODPP()", v-if="index == 0 && plan_con.state.order == 0")
                          | Actualizar                    
        .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-else)
          .col-12.text-center.rounded-lg.ad_bg-gray.pt-3
            p.muted No hay objetivos para esta semana
            table.w-100.text-center.table-rounded-body
              thead
                tr
                  th
                  th.text-left Competencia
                  th Actividad
                  th Plazo
                  th Semanas activo
                  th Cumplimiento
                  th
              tbody
                tr
                  td
                    div.pr-0
                      span.num_circle.ad_bg-secondary --
                  td.w-50.text-left
                    div
                      | ...
                  td
                    div
                      | ...
                  td
                    div.justify-content-center
                      span.text-nowrap
                        | -- sem
                  td
                    div.justify-content-center
                      span.text-nowrap(:class="plazo > activo ? 'ad_text-successDark' : 'ad_text-danger'")
                        | -- sem
                  td
                    div.justify-content-center
                      i.icon-blocked.icon--1-5x.align-middle
                  td
                    div.pr-0
                      a.btn.btn-secondary.px-3.py-1(title="Actualizar", @click.stop="opendrawerODPP()", v-if="plan_con.state.order == 0")
                        | Actualizar
    .col-12.mt-3
      .card.ad_border1-secondary.rounded-xl
        h3.ad_text-primary
          i Desafíos
        .col-12.text-center.rounded-lg.ad_bg-gray.pt-3.mb-2(v-if="weeklychallengescon.length == 0")
          p.muted Aún no ha seleccionado objetivos para esta semana
          table.w-100.text-center.table-rounded-body
            thead
              tr
                th
                th.w-50.text-left Desafío
                th Fecha compromiso
                th Cumplimiento
                th
            tbody
              tr
                td
                  div.pr-0
                    span.num_circle.ad_bg-secondary --
                td.w-70.text-left
                  div.pl-2
                    | ...
                td.w-10
                  div.justify-content-center
                    span.text-nowrap
                      | ...
                td.w-5
                  div.justify-content-center
                    i.icon-blocked.icon--1-5x.align-middle
                td.w-10
                  div.justify-content-end
                    a.btn.btn-secondary.px-3.py-1(title="Actualizar", @click.stop="openDrawerDS()", v-if="plan_con.state.order == 0")
                      | Actualizar
        .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-if="weeklychallengescon.length > 0")
          .d-flex.row
            .col-12
              table.w-100.text-center.table-rounded-body
                thead
                  tr
                    th
                    th.w-50.text-left Desafío
                    th Fecha compromiso
                    th Cumplimiento
                    th(v-if="indexd == 0 && plan_con.state.order == 0")
                tbody
                  tr(v-for="(wcc, indexd) in weeklychallengescon")
                    td
                      div.pr-0
                        span.num_circle.ad_bg-secondary {{indexd + 1}}
                    td.w-70.text-left
                      div.pl-2
                        | {{wcc.description}}
                    td.w-10
                      div.justify-content-center
                        span.text-nowrap
                          | {{wcc.date | DateFormat}}
                    td.w-5
                      div.bg-white.justify-content-center(v-if="wcc.accomplished == true")
                        i.icon-cross.ad_text-danger.icon--1-5x.align-middle
                      div.bg-white.justify-content-center(v-if="wcc.accomplished == false")
                        i.icon-cross.ad_text-danger.icon--1-5x
                    td.w-10(v-if="indexd == 0" rowspan="2")
                      div.justify-content-end
                        a.btn.btn-secondary.px-3.py-1(title="Actualizar", @click.stop="openDrawerDS()")
                          | Actualizar


  v-navigation-drawer(v-model='drawerODPP', app='', temporary='', right='', width='800')
    header.ad_bg-primary.pt-2.pb-2.px-4
      h2.h2.text-white.mt-4
        i Objetivos de Desarrollo Personal (propios)

    .card-body
      section.py-4.px-2
        .row
          .col-12.d-flex.align-items-center.justify-content-between.py-2
            h3.ad_text-primary.my-2
              i Competencias del consultor
            
        .card.rounded-lg.ad_border1-secondary.p-0.mb-4
          .card-body
            .row.mb-1
              .col.font-italic.mr-3.d-flex.justify-content-between
                  span Competencia
              .col.font-italic.mr-3.d-flex.justify-content-between
                span Actividad
                span
              .col-3.font-italic.text-center
                span Cumple
              .col-1
            .row.desafios-semanales(v-if="personaldevelopments.length > 0")
              .col-12.d-flex.flex-row(v-for="(pdc, indexpdc) in personaldevelopments")
                .col.pl-0.py-3.border-bottom
                  .row.ad_bg-gray.rounded-xl.py-3.m-0
                    .w-75.px-3
                      | {{pdc.category.name}}
                .col.pl-0.py-3.border-bottom
                  .row.ad_bg-gray.rounded-xl.py-3.m-0
                    .w-75.px-3
                      | {{pdc.subcategory.name}}
                    .w-25.px-3.text-right
                      strong {{pdc.date_limit | DateFormat}}
                .col-auto.d-flex.px-0.py-3.border-bottom.align-items-center.justify-content-around
                  c-form-radio.mr-2.ad_radio.ad_radio-cumple(:name="'desafio' + indexpdc" v-model="pdc.accomplished" value="true" label="Si")
                  c-form-radio.ml-2.ad_radio.ad_radio-nocumple(:name="'desafio' + indexpdc" v-model="pdc.accomplished" value="false" label="No")
                .col-auto.pr-0.py-3.d-flex.align-items-center.border-bottom
                  button.btn.btn__small.btn-secondary-border.font-weight-bold(@click.stop="closePDC(pdc, indexpdc)")
                    | Cerrar
              .col-12.ad_text-dangerDark(v-if="errorPD")
                p.ad_bg-dangerLight.px-3.py-2.rounded
                  i.fas.fa-times-circle.mr-1
                  | Debe seleccionar si se cumplió o no este Objtivo de Desarrollo
              
            .row.d-flex.justify-content-center.my-3
              .col-auto
                b-button.btn.btn__medium.btn-success.py-2.w-100(v-if="personaldevelopments.length < 2",@click="objetivodpp = !objetivodpp")
                  i.fas.fa-plus-circle.mr-1
                  span.m-0.font-weight-bold Añadir Objetivo de Desarrollo Personal (propios)
            b-collapse(v-model="objetivodpp" id="objetivoDP")
              .card.py-0.border-0.rounded-xl.ad_bg-gray
                .card-body
                  .row
                    form.col-12
                      .h5.mb-3.font-weight-bold.font-italic
                        | Crear Nueva competencia
                      .form-group.flex-wrap
                        label Competencia
                        .ad_select
                          select(v-model='selectedCategoria', @change='getSubByCat($event)')
                            option(value="null" selected) Selecciona competencia
                            option(:value="category" v-for="category in categories") {{category.name}}
                      .row
                        .form-group.flex-wrap.col-9
                          label Actividad
                          .ad_select
                            select(v-model='selectedSubcategoria')
                              option(value="null" selected) Selecciona actividad
                              option(:value="objetivo" v-for="objetivo in subcategories") {{objetivo.name}}
                        .form-group.flex-wrap.col-3
                          label.w-100 Plazo
                          //- input.form-control.ad_border1-secondary.rounded-xl.w-100(type="number" max="20" placeholder="0")
                          v-menu.datepicker(ref='dates', v-model='dates', :close-on-content-click='true', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                            v-text-field.date-input.p-0(slot='activator', v-model='compromisoDatePD', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                            v-date-picker(v-model='compromisoDatePD', no-title='', scrollable='' locale="es", @input="menu = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
                      .row.mt-4.mb-2
                        .col.d-flex.justify-content-between
                          button.btn.btn-graySecondary-border.btn__medium(@click="objetivodpp = !objetivodpp")
                            i.fas.fa-chevron-circle-left.ad_text-grayMedio.mr-1
                            span.ad_text-grayMedio Cancelar
                          button.btn.btn-success-border.btn__medium(@click.stop="createPersonalDevCon()")
                            span.font-weight-bold.pl-2 Crear
                            i.fas.fa-plus-circle.ml-1
        .row
          .col-12
            h3.ad_text-primary.my-2
              i Comentarios
            .form-group.align-items-center
              textarea.form-control(placeholder="Ingrese comentarios", rows="4", v-model="commentToSend")
        .form-group.justify-content-between.mt-3
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerODPP = !drawerODPP")
            i.far.fa-times-circle.fa-1x.mr-2.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="updatePD('Desarrollo Personal')")
            span.font-weight-bold Grabar
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
        
        hr.my-4
        
        h3.ad_text-grayMedio.mb-2
          i Historial de comentarios
        div(v-if="comments.length > 0")
          div(v-for="c in comments")
            .row.mb-3
              .col-4.pr-0
                p.font-weight-bold.m-0 {{c.user.name}}
                small.d-block {{c.date | DateFormat}}
                small.d-block {{c.date | HourFormat}} hrs.
                small.d-block {{c.type}}
              .col-8.pl-0
                .dialog-box
                  p {{c.comment}}
          b-pagination(
              v-model="currentPageDp"
              :total-rows="totalRowsDp"
              :per-page="perPage",
              @input="selectedPage('Desarrollo Personal')",
              class="my-0")

  v-navigation-drawer(v-model='drawerDS', app='', temporary='', right='', width='800')
    header.ad_bg-primary.pt-2.pb-2.px-4
      h2.h2.text-white.mt-4
        i Desarrollo personal (propio)

    .card-body
      section.py-4.px-2
        .row
          .col-12.d-flex.align-items-center.justify-content-between.py-2
            h3.ad_text-primary.my-2
              i Desafíos
            
        .card.rounded-lg.ad_border1-secondary.p-0.mb-4
          .card-body
            .row(v-if="weeklychallengescon.length > 0")
              .col.font-italic.d-flex.pr-0.justify-content-between
                span Desafío
                span Compromiso
              .col-3.font-italic.text-center
                span Cumple
              .col-1
            .row.desafios-semanales
              .col-12.d-flex.flex-row(v-for="(wcc, ind) in weeklychallengescon")
                .col.pl-0.py-3.border-bottom
                  .row.ad_bg-gray.rounded-xl.py-3.m-0
                    .w-75.px-3
                      | {{wcc.description}}.
                    .w-25.px-3.text-right
                      strong {{wcc.date| DateFormat}}
                .col-auto.d-flex.px-0.py-3.border-bottom.align-items-center.justify-content-around
                  c-form-radio.mr-2.ad_radio.ad_radio-cumple(:name="'desafio' + ind" v-model="accomplishedWCC[ind]" value="true" label="Si")
                  c-form-radio.ml-2.ad_radio.ad_radio-nocumple(:name="'desafio' + ind" v-model="accomplishedWCC[ind]" value="false" label="No")
                .col-auto.pr-0.py-3.d-flex.align-items-center.border-bottom
                  button.btn.btn__small.btn-secondary-border.font-weight-bold(@click.stop="closeWCC(wcc, ind)")
                    | Cerrar
              .col-12.ad_text-dangerDark(v-if="errorWC")
                p.ad_bg-dangerLight.px-3.py-2.rounded
                  i.fas.fa-times-circle.mr-1
                  | Debe seleccionar si se cumplió o no este Desafio
              
            .row.d-flex.justify-content-center.my-3
              .col-auto
                b-button.btn.btn__medium.btn-success.py-2.w-100(v-if="weeklychallengescon.length < 2", @click="objetivodpp = !objetivodpp")
                  i.fas.fa-plus-circle.mr-1
                  span.m-0.font-weight-bold Añadir Desafío
            b-collapse(v-model="objetivodpp" id="objetivoDP")
              .card.py-0.border-0.rounded-xl.ad_bg-gray
                .card-body
                  .row
                    form.col-12
                      .h5.mb-3.font-weight-bold.font-italic
                        | Crear Desafío
                      .form-group.flex-wrap
                        label.w-100 Descripción
                        textarea.form-control.ad_border1-secondary(rows="3", v-model="descriptionWC")
                      .form-group.flex-wrap
                        label.w-100 Fecha de compromiso
                        v-menu.datepicker(ref='dates', v-model='dates', :close-on-content-click='true', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                          v-text-field.date-input.p-0(slot='activator', v-model='compromisoDate', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                          v-date-picker(v-model='compromisoDate', no-title='', scrollable='' locale="es", @input="menu = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
                  .row.mt-4.mb-2
                    .col.d-flex.justify-content-between
                      button.btn.btn-graySecondary-border.btn__medium(@click="objetivodpp = !objetivodpp")
                        i.fas.fa-chevron-circle-left.ad_text-grayMedio.mr-1
                        span.ad_text-grayMedio Cancelar
                      button.btn.btn-success-border.btn__medium(@click.stop="createWeeklyCC()")
                        span.font-weight-bold.pl-2 Crear
                        i.fas.fa-plus-circle.ml-1
        .row
          .col-12
            h3.ad_text-primary.my-2
              i Comentarios
            .form-group.align-items-center
              textarea.form-control(placeholder="Ingrese comentarios", rows="4", v-model="commentToSend")
        .form-group.justify-content-between.mt-3
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawerDS = !drawerDS")
            i.far.fa-times-circle.fa-1x.mr-2.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="updateWc('Desafio Semanal')")
            span.font-weight-bold Grabar
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
        
        hr.my-4
        
        h3.ad_text-grayMedio.mb-2
          i Historial de comentarios
        div(v-if="comments.length > 0")
          div(v-for="c in comments")
            .row.mb-3
              .col-4.pr-0
                p.font-weight-bold.m-0 {{c.user.name}}
                small.d-block {{c.date | DateFormat}}
                small.d-block {{c.date | HourFormat}} hrs.
                small.d-block {{c.type}}
              .col-8.pl-0
                .dialog-box
                  p {{c.comment}}
          .row.mb-3
            b-pagination(
              v-model="currentPageDs"
              :total-rows="totalRowsDs"
              :per-page="perPage",
              @input="selectedPage('Desafio Semanal')",
              class="my-0")
  v-navigation-drawer(v-model='drawerComentarios', app='', temporary='', right='', width='800')
      header.ad_bg-primary.pt-2.pb-2.px-4
        h2.h2.text-white.mt-4
          i Comentarios Generales
      section.px-2.overflowy-auto
        .card-body
          h4.ad_text-primary
            i Resumen
          .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-if="personaldevelopments.length > 0")
            .d-flex.row
              .col-12
                table.w-100.text-center.table-rounded-body
                  thead
                    tr
                      th
                      th.w-40.text-left Objetivos de desarrollo personal
                      th Categoría
                      th Plazo
                      th Semanas activo
                      th.p-0 Cumple
                  tbody
                    tr(v-for="(pdc, index) in personaldevelopments")
                      td
                        div.pr-0
                          span.num_circle.ad_bg-secondary {{index + 1}}
                      td.w-50.text-left
                        div
                          | {{pdc.subcategory.name}}
                      td
                        div
                          | {{pdc.category.name}}
                      td
                        div.justify-content-center
                          span.text-nowrap
                            | {{pdc.date_limit | Week}} sem
                      td
                        div.justify-content-center
                          span.text-nowrap(:class="plazo > activo ? 'ad_text-successDark' : 'ad_text-danger'")
                            | {{pdc.date | WeekDuratByWeek}} sem
                      td
                        div.justify-content-center
                          i.icon-checkmark.ad_text-success.icon--1-5x.align-middle                
          .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-if="personaldevelopments.length == 0")
            .col-12.text-center.rounded-lg.ad_bg-gray.pt-3
              p.muted No hay objetivos para esta semana

          .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-if="weeklychallengescon.length > 0")
            .d-flex.row
              .col-12
                table.w-100.text-center.table-rounded-body
                  thead
                    tr
                      th.w-5
                      th.text-left Desafíos de la semana
                      th Compromiso
                      th.p-0 Cumple
                  tbody
                    tr(v-for="(wwcc, indwcc) in weeklychallengescon")
                      td
                        div.pr-0
                          span.num_circle.ad_bg-secondary {{indwcc + 1}}
                      td.w-70.text-left
                        div.pl-2
                          | {{wwcc.description}}
                      td.w-10
                        div.justify-content-center
                          span.text-nowrap
                            | {{wwcc.date | DateFormat}}
                      td.w-5
                        div.justify-content-center(v-if="wwcc.accomplished == true")
                          i.icon-cross.ad_text-danger.icon--1-5x.align-middle
                        div.justify-content-center(v-if="wwcc.accomplished == false")
                          i.icon-cross.ad_text-danger.icon--1-5x
          .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-if="weeklychallengescon.length == 0")
            p.muted Aún no ha seleccionado objetivos para esta semana
          hr.my-4
          
          .row
            .col-12
              h3.ad_text-primary.my-2
                i Comentarios
              .form-group.align-items-center
                textarea.form-control(placeholder="Ingrese comentarios", rows="4", v-model="commentToSend")
          .form-group.justify-content-between.mt-3
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(v-if="personaldevelopments.length < 2", @click="drawerComentarios = !drawerComentarios")
              i.far.fa-times-circle.fa-1x.mr-2.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addNoPCommentToPlanCon('null')")
              span.font-weight-bold Añadir comentario
              i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-2
            i Historial de comentarios
          div(v-if="comments.length > 0")
            div(v-for="c in comments")
              .row.mb-3
                .col-4.pr-0
                  p.font-weight-bold.m-0 {{c.user.name}}
                  small.d-block {{c.date | DateFormat}}
                  small.d-block {{c.date | HourFormat}} hrs.
                  small.d-block {{c.type}}
                .col-8.pl-0
                  .dialog-box
                    p {{c.comment}}
            b-pagination(
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage",
              @input="selectedPage('null')",
              class="my-0")

</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "ConsDesarrolloPersonalExt",
  props: ["clickedNext", "currentStep"],
  components: {},
  data() {
    return {
      activo: 9,
      activo2: 3,
      accomplishedPDC: null,
      accomplishedWCC: [],
      categories: [],
      challenges: [],
      commentToSend: "",
      comments: [],
      compromisoDatePD: null,
      compromisoDate: null,
      datelimit: null,
      drawerDS: null,
      drawerODPP: null,
      drawerComentarios: null,
      desafio: null,
      date: null,
      dates: false,
      descriptionWC: null,
      errorWC: false,
      errorPD: false,
      gestionadoDS: false,
      gestionadoODPP: false,            
      objetivodpp: false,      
      menu: false,
      overlay: false,
      personaldevelopments: [],
      plan_con: null,
      plazo: 5,      
      plazo2: 6,          
      subcategories: [],
      selectedCategoria: null,
      selectedSubcategoria: null,          
      weeklychallengescon: [],
      arrayTest: [],
      currentPage: 1,
      currentPageDs: 1,     
      currentPageDp: 1,
      perPage: 5,
      totalRows: 0,
      totalPages: 0,
      totalRowsDp: 0,
      totalRowsDs: 0,
      totalPagesDp: 0,
      totalPagesDs: 0,
      indexd: 0     
    };
  },
  methods: {
    ...mapActions('categorycon', [
      'categoriesconList'
    ]),
    ...mapActions('subcategorycon', [
      'byCategoryconId'
    ]),
    ...mapActions('weeklychallengecon', [
      'getWCClistByPlanConId', 'createWCC', 'updateBWeeklyChallengeCon', 'addToWeeklyChallengeList', 'closeWeeklyChallengecon', 'subsToWeeklyChallengeList'
    ]),
    ...mapActions('personaldevelopmentcon', [
      'getPDClistByPlanConId', 'createPDC', 'updateBPersonalDevelopmentCon', 'closePersonalDevelopment', 'addToPersonalDevelopmentList', 'subsToPersonalDevelopmentList'
    ]),
    ...mapActions('plan_con', [
      'addComment'
    ]),
    ...mapActions('comments_plancon', [
      'getCommentsByPlanLider', 'createCommentPlanCon'
    ]),
    canContinue (){  
      if (this.gestionadoDS && this.gestionadoODPP) {
        this.$emit('can-continue', {value: true})
      }
    },
    canContinueDS (){
      if (this.gestionadoDS && this.gestionadoODPP) {
        this.$emit('can-continue', {value: true})
      }
      this.gestionadoDS = true
      return this.gestionadoDS
    },
    canContinueODPP (){  
      if (this.gestionadoDS && this.gestionadoODPP) {
        this.$emit('can-continue', {value: true})
      }
      this.gestionadoODPP = true
      return this.gestionadoODPP
    },
    getPersonaleDevConlist() {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.getPDClistByPlanConId({plan: vm.plan_con._id}).then(() => {
          vm.personaldevelopments = vm.$store.getters['personaldevelopmentcon/getPersonalDevelopments']
          resolve()
        }, (error) => {
          reject(error)
        })
      })      
    },
    getWCCList() {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.getWCClistByPlanConId({plan: vm.plan_con._id}).then((response) => {
          vm.weeklychallengescon = vm.$store.getters['weeklychallengecon/getWeeklyChallengescon']
          resolve()
        }, (error) => {
          reject(error)
        })
      })  
    },
    getCategories() {
      const vm = this
      vm.categoriesconList().then(() => {
        vm.categories = vm.$store.getters['categorycon/getCategoriescon']
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    getSubByCat() {
      const vm = this
      vm.byCategoryconId(vm.selectedCategoria._id).then(() => {
        vm.subcategories = vm.$store.getters['subcategorycon/getSubcategoriescon']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    addCommentToLiderPlan: function(type) {
      const vm = this
      return new Promise((resolve, reject) => {
        if (vm.commentToSend != null) {
          const data = {
            plan_lider: vm.plan_con._id,
            user: vm.user.id,
            type: type,
            date: moment(),
            comment: vm.commentToSend
          }
          vm.createCommentPlanCon(data).then((response) => {
            vm.commentToSend = null
            vm.currentPlanComments = vm.$store.getters['plan_lider/getComments']
            resolve()
          }, (error) => {
            reject(error)
          })
        } else {
          resolve()
        }
      })      
    },
    addAutoCommentToLiderPlan: function(type, autocomment) {
      const vm = this
      return new Promise((resolve, reject) => {
        const data = {
          plan_lider: vm.plan_con._id,
          user: vm.user.id,
          type: type,
          date: moment(),
          comment: autocomment
        }
        vm.createCommentPlanCon(data).then((response) => {
          vm.currentPlanComments = vm.$store.getters['plan_lider/getComments']
          resolve()
        }, (error) => {
          reject(error)
        })
      })      
    },
    createPersonalDevCon() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      if (vm.personaldevelopments.length < 2) {
        if (vm.compromisoDatePD !== null && vm.selectedCategoria !== null && vm.selectedSubcategoria !== null) {
          let data = {
            date: moment(),
            description: "",
            date_limit: vm.compromisoDatePD,
            category: vm.selectedCategoria,
            subcategory: vm.selectedSubcategoria,
            plan: vm.plan_con._id,
            accomplished: false
          }
          // vm.personaldevelopments.push(data)
          vm.addToPersonalDevelopmentList(data)
          vm.compromisoDatePD = null
          vm.selectedCategoria = null
          vm.selectedSubcategoria = null
          vm.objetivodpp = false
          loading.hide()
        } else {
          // vm.objetivodpp = false
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Debe agregar todos los campos antes de agregar a la lista.',
            closeable: true,
            duration: 5000
          })
        }
      } else {
        vm.objetivodpp = false
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'No puede agregar mas de dos desarrollo personal.',
          closeable: true,
          duration: 5000
        })
      }
    },
    createWeeklyCC() {
      const vm = this
      const loading = vm.$toast.loading('Agregando...')
      if (vm.weeklychallengescon.length < 2) {
        if (vm.compromisoDate !== null && vm.descriptionWC !== null) {
          let data = {
            date: vm.compromisoDate,
            description: vm.descriptionWC,
            plan: vm.plan_con._id,
            accomplished: false
          }
          // vm.weeklychallengescon.push(data)
          vm.addToWeeklyChallengeList(data)
          vm.descriptionWC = null
          vm.compromisoDate = null
          // vm.objetivodpp = false
          loading.hide()
        } else {
          vm.objetivodpp = false
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Debe completar todos los campos antes de agregar a la lista.',
            closeable: true,
            duration: 5000
          })
        }       
      } else {
        vm.objetivodpp = false
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'No puede agregar mas de dos desafios semanales.',
          closeable: true,
          duration: 5000
        })
      }
    },
    addNoPCommentToPlanCon(type) {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      if (vm.commentToSend != null) {
        const data = {
            plan_lider: vm.plan_con._id,
            user: vm.user.id,
            type: type,
            date: moment(),
            comment: vm.commentToSend
          }
        vm.createCommentPlanCon(data).then(() => {
          vm.drawerComentarios = false
          loading.hide()
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Comentario agregado',
            closeable: true,
            duration: 5000
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      } else {
        loading.hide()
        vm.$notify({          
          type: 'danger',
          title: 'Notificación',
          content: 'Debe ingresar un comentario',
          closeable: true,
          duration: 5000
        })
      }
    },
    addCommentToPlanCon() {
      const vm = this
      return new Promise((resolve, reject) => {
        if (vm.commentToSend != null) {
          const data = {
            planid: vm.plan_con._id,
            comment: {
              user: {name: vm.user.name, username: vm.user.username, _id: vm.user._id},
              date: moment(),
              comment: vm.commentToSend
            }
          }
          vm.addComment(data).then(() => {
            vm.drawerComentarios = false
            resolve()
          }, (error) => {
            reject(error)
          })
        } else {
          resolve()
        }
      })
    },
    closePDC(pdc, indexpdc) {
      const vm = this
      const loading = vm.$toast.loading('Cerrando...')
      if (pdc.hasOwnProperty('_id')) {
        vm.addAutoCommentToLiderPlan('Competencias','Cierre competencias personales').then(() => {
          vm.closePersonalDevelopment({
            id: pdc._id, 
            planid: vm.plan_con._id, 
            accomplished: pdc.accomplished
          }).then((response) => {
            vm.personaldevelopments = vm.$store.getters['personaldevelopmentcon/getPersonalDevelopments']
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Desarrollo personal eliminado',
              closeable: true,
              duration: 5000
            })        
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })      
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        })
      } else {
        vm.subsToPersonalDevelopmentList(indexpdc)
        vm.personaldevelopments = vm.$store.getters['personaldevelopmentcon/getPersonalDevelopments']
        loading.hide()
      }
    },
    closeWCC(wcc, indexwcc) {
      const vm = this
      const loading = vm.$toast.loading('Cerrando...')
      if (wcc.hasOwnProperty('_id')) {
        vm.addAutoCommentToLiderPlan('Desafio Semanal','Cierre desafio semanal').then(() => {
          vm.closeWeeklyChallengecon({
            id: wcc._id, 
            planid: vm.plan_con._id, 
            accomplished: wcc.accomplished 
          }).then((response) => {
            vm.weeklychallengescon = vm.$store.getters['weeklychallengecon/getWeeklyChallengescon']
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Desafio semanal eliminado',
              closeable: true,
              duration: 5000
            }) 
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })      
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error,
            closeable: true,
            duration: 5000
          })
        })        
      } else {
        vm.subsToWeeklyChallengeList(indexwcc)
        vm.weeklychallengescon = vm.$store.getters['weeklychallengecon/getWeeklyChallengescon']
        loading.hide()
      }
    },
    checkAc(element) {
      const vm = this
      let accomplished = ''
      let ok = true

      for (let index in vm[element]) {
        if (vm[element][index].hasOwnProperty('_id')) {
          if (vm[element][index]['accomplished'] == null) {
            ok = false
          }
        }
      }

      return ok
    },
    updateWc(type) {
      const vm = this
      const loading = vm.$toast.loading('Actualizando...')
      if (vm.checkAc('weeklychallengescon')) {
        vm.addCommentToLiderPlan(type).then(() => {
          vm.updateBWeeklyChallengeCon({
            data: vm.weeklychallengescon,
            plan: vm.plan_con._id
          }).then((plupdated) => {
            vm.errorWC = false
            vm.commentToSend = null
            vm.weeklychallengescon = plupdated
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Desafio semanal agregado',
              closeable: true,
              duration: 5000
            })
          }, (error) => {
            vm.errorWC = false
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })        
      } else {
        loading.hide()
        vm.errorWC = true
      }
    },
    updatePD(type) {
      const vm = this
      const loading = vm.$toast.loading('Actualizando...')
      if (vm.checkAc('personaldevelopments')) {
        vm.addCommentToLiderPlan(type).then(() => {
          vm.updateBPersonalDevelopmentCon({
            data: vm.personaldevelopments,
            plan: vm.plan_con._id
          }).then((plupdated) => {
            vm.errorPD = false
            vm.commentToSend = null
            vm.personaldevelopments = plupdated
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Desarrollo personal agregado',
              closeable: true,
              duration: 5000
            })
          }, (error) => {
            vm.errorWC = false
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })        
      } else {
        loading.hide()
        vm.errorPD = true
      }
    },
    openGeneralComments: function () {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')         
      vm.getComments(null).then(() => {
        vm.drawerComentarios = true
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      }) 
    },
    getComments(type) {
      return new Promise ((resolve, reject) => {
        const vm = this

        let varPag = ''
        if (type == 'Desafio Semanal') {
          varPag = 'Ds'
        } else if (type == 'Desarrollo Personal') {
          varPag = 'Dp'
        }

        vm.getCommentsByPlanLider({id: vm.plan_con._id, type: type, pagination: {page: vm[`currentPage${varPag}`], perPage: vm.perPage}}).then((res) => {
          vm.comments = res.docs;            
            vm[`totalRows${varPag}`] = res.total;
            vm[`totalPages${varPag}`] =  res.totalPages;
          resolve()
        }, (error) => {
          reject(error)
        });
      })      
    },
    openDrawerDS() {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.getComments('Desafio Semanal').then(() => {
        vm.drawerDS = !vm.drawerDS;
        loading.hide();
      }, (error) => {
        loading.hide();
        reject(error)
      });
    },
    opendrawerODPP() {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.getComments('Desarrollo Personal').then(() => {
        vm.drawerODPP = !vm.drawerODPP;
        loading.hide();
      }, (error) => {
        loading.hide();
        reject(error)
      });
    },
    selectedPage(type) {
      const vm = this
      const loading = vm.$toast.loading('Cargando...')
      vm.getComments(type).then(() => {
        loading.hide()
        vm.drawerObjetivos = true
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },

  },
  watch: {
    drawerComentarios: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    drawerDS: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    },
    drawerODPP: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    }
  },
  updated() {
    const vm = this;
  },
  computed: {
  },
  mounted() {
    const vm = this;
    const loading = vm.$toast.loading('Cargando...')
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.plan_con = vm.$store.getters['plan_con/getPlan']
    vm.getCategories()
    vm.getWCCList().then(() => {
      vm.getPersonaleDevConlist().then(() => {
        vm.$emit('completed-step', {value: true});
        vm.$emit("can-continue", { value: true });
        loading.hide()
      }, (e) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }, (erorr) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })    
  }
};
</script>



// WEBPACK FOOTER //
// src/views/ps-consultor-externo-desarrollopersonal.vue